export const DEFAULT_REFETCH_INTERVAL = 60_000; // 1 minute
